<template>
    <div>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'债权融资管理'},{name:'融资租赁申请列表'}]" :title="'融资租赁申请列表'"/> -->
            <!-- 查询条件 -->
            <div class="retrieve border" ref="condition">
                <div class="left">
                    <div class="child">
                        <span class="name">申请结果</span>
                        <el-select v-model="sendInfoOne.rate" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">提交日期</span>
                        <el-date-picker
                            size="small"
                            v-model="dateS"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :default-time="['24:00:00','23:59:59']"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="getSelect" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="getValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="retrieval" class="retrievalBtn">查询</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                :data="tableData"
                @sort-change="sortChange"
                 ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    
                    label="公司名称">
                    <template slot-scope="scope">
                        <div class="tableName" @click="viewDetails(scope.row)">{{scope.row.financingName}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="createName"
                    show-overflow-tooltip
                    
                    label="姓名">
                </el-table-column>
                <el-table-column
                    prop="applicant"
                    show-overflow-tooltip
                    
                    label="申请人姓名">
                </el-table-column>
                <el-table-column
                    prop="contactPhone"
                    show-overflow-tooltip
                    
                    width="200"
                    label="联系手机号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="提交时间">
                </el-table-column>
                <el-table-column
                    prop="rateValue"
                    show-overflow-tooltip
                    
                    label="申请结果">
                </el-table-column>
                <el-table-column
                    v-if="authorities.indexOf('sys:permission:background:lease:finance:apply:list:button:view') != -1"
                    label="操作"
                    
                    width="100">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain  v-if="authorities.indexOf('sys:permission:background:lease:finance:apply:list:button:view') != -1" @click="check(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref='pagination'>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="sendInfoOne.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize">
                </el-pagination>
            </div>
            <!-- 弹出成模块 -->
            <!-- 查看明细 -->
            <el-dialog
                title="申请信息"
                :visible.sync="dialogInfo"
                :close-on-click-modal="false"
                width="50%">
                <div class="basic">
                    <div class="boxChild">
                        <div class="basisTitle">提交信息</div>
                        <div class="child">
                            <div class="name">申请人姓名：</div>
                            <div class="content">{{tableDetail.applicant}}</div>
                        </div>
                        <div class="child">
                            <div class="name">联系手机号：</div>
                            <div class="content">{{tableDetail.contactPhone}}</div>
                        </div>
                        <div class="child">
                            <div class="name">公司全称：</div>
                            <div class="content">{{tableDetail.applyCompany}}</div>
                        </div>
                        <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{tableDetail.dealWithRemark}}</div>
                        </div>
                        <div class="attachment" v-if="tableDetail.fileList&&tableDetail.fileList.length>0">
                            <div class="name">附件：</div>
                            <ul class="content">
                                 <li v-for="(item,index) in tableDetail.fileList" :key="index">
                                    <span>{{item.fileName}}</span><i class="el-icon-download" @click="open(item)"></i>
                                </li>
                            </ul>
                        </div>
                        <div class="child">
                            <div class="name">提交时间：</div>
                            <div class="content">{{tableDetail.createTime}}</div>
                        </div>
                    </div>
                    <div class="boxChild">
                        <div class="basisTitle">申请结果信息</div>
                        <div class="child">
                            <div class="name">申请结果：</div>
                            <div class="content">{{tableDetail.checkStatusValue}}</div>
                        </div>
                        <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{tableDetail.applyRemark}}</div>
                        </div>
                        <div class="child">
                            <div class="name">更新账号：</div>
                            <div class="content">{{tableDetail.modifyUserName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">更新时间：</div>
                            <div class="content">{{tableDetail.updateTime}}</div>
                        </div>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import timeMixins from "@/mixins/timeFormat";
// import breadcrumb from '../../components/breadcrumb';
export default {
    mixins:[timeMixins],
    components:{
        // breadcrumb
    },
    data(){
        return{
            loading:false,
            bHeight: void 0,
            authorities:JSON.parse(window.localStorage.getItem('authorities')),
            tab:1,//选项卡
            getSelect:'',//检索下拉的值
            getValue:'',//检索输入框的值
            dateS:[],//日期
            options: [{
                value: '2',
                label: '公司名称'
                }, {
                value: '3',
                label: '账号'
            }, {
                value: '4',
                label: '姓名'
            }, {
                value: '5',
                label: '申请人姓名'
            }, {
                value: '6',
                label: '联系方式'
            }],//检索下拉
            sendInfoOne:{
                currentPage:1,//当前页
                pageSize:10,//页条数
                endDate:'',//结束时间
                startDate:'',//开始时间
                id:"",//申请id
                name:'',//姓名
                rate:"",//申请结果
                userName:"",//账号
                financingName:'',//公司名称
                contactPhone:'',//手机号
                checkStatus:'',//申请审核状态
                applicant:'',//申请人姓名
                property:null,//排序字段
                direction:null,//排序方式
            },//检索提交数据
            tableData:[],//表格数据
            currentPage:1,//当前页
            dialogInfo:false,//查看明细弹出层
            statusList:[],//申请结果
            scopeList:[],
            totalSize:null,
             tableDetail:{
                applicant:"",//申请人姓名：
                contactPhone:"",//联系手机号：
                applyCompany:"",//公司全称：
                dealWithRemark:"",//说明：
                fileList:[],//附件
                createTime:"",//提交时间：
                checkStatusValue:"",//申请结果：
                applyRemark:"",//申请说明：
                modifyUserName:"",//更新账号：
                updateTime:"",//更新时间：
            }

        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    methods:{
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        // 切换选项啦
        changeTab:function(num){
            this.tab=num;
        },
        //检索事件
        retrieval:function(){
			this.getData();
		},
        //表格跳转详情
        viewDetails:function(row){
            this.$router.push({path:'/debtManagement/applyDetail',query:{id:row.loanId,index:'/debtManagement/applyList'}})
        },
        //表格排序事件
        sortChange:function({ column, prop, order }){
            if(order=='ascending'){
                order='asc';
            }else{
                order='desc';
            }
            this.sendInfoOne.property=prop;
            this.sendInfoOne.direction=order;
            this.getData();
        },
        //查看明细
        check:function(row){
            // this.dialogInfo=true;
            // this.$axiosc.get('backstage/financial/leasing/apply/details/'+row.id).then(res=>{
            //     if(res.code == 200){
            //         this.tableDetail = res.data
            //     }else{
            //         this.$alert(res.msg)
            //     }
            // })
            this.$router.push({path:'/debtManagement/applyList/detail',query:{id:row.id,index:'/debtManagement/applyList'}})
        },
        //分页功能模块
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            this.getData();
        },
        //获取字典
        getDic:function(){
            this.$axiosz.get('backstage/sysDict/isShow/FINANCIAL_LEASING_RATE').then((r)=>{ //审核结果
                if(r.code==200){
                    this.statusList=r.data;
                }
            })
        },
        getData(){
            this.loading = true
            if(this.dateS&&this.dateS.length>0){
                this.sendInfoOne.startDate=this.dateS[0];
                this.sendInfoOne.endDate=this.dateS[1];
            }else{
                this.sendInfoOne.startDate=null;
                this.sendInfoOne.endDate=null;
            }
            this.sendInfoOne.id="";//申请id
            this.sendInfoOne.userName='';//账号
            this.sendInfoOne.name='';//姓名
            this.sendInfoOne.applicant='';//申请人姓名
			this.sendInfoOne.financingName='';//公司名称
			this.sendInfoOne.contactPhone='';//联系方式
            if(this.getSelect=='1'){ //申请id
                this.sendInfoOne.id=this.getValue;
            }else if(this.getSelect=='2'){ //公司名称
                this.sendInfoOne.financingName=this.getValue;
            }else if(this.getSelect=='3'){ //账号
                this.sendInfoOne.userName=this.getValue;
            }else if(this.getSelect=='4'){ //姓名
                this.sendInfoOne.name=this.getValue;
            }else if(this.getSelect=='5'){ //申请人姓名
                this.sendInfoOne.applicant=this.getValue;
            }else if(this.getSelect=='6'){ //联系方式
                this.sendInfoOne.contactPhone=this.getValue;
            }
            this.$axiosc.get('backstage/financial/leasing/apply/all/list',{params:this.sendInfoOne}).then(res=>{
                this.loading = false
                if(res.code == 200){
                    this.tableData = res.data.content
                    this.totalSize=res.data.totalElements;
                }else{

                }
            }).catch(e=>{
              this.loading  = false
            })
        }
    },
    mounted(){
        const that = this
        that.getDic();
        that.getData();
        let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 30
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 30
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    }
}
</script>

<style lang="scss" scoped>
.warp{
    .detailBas{
        margin-top: 20px;
    }
}
</style>